module.exports = __webpack_public_path__ + "static/media/analytics.b6ac617a.svg";